import React from 'react';

import { LayoutPageHeading } from 'src/modules/layout';
import LayoutPage from 'src/modules/layout/components/page/LayoutPage';
import { useLocale } from 'src/modules/locale';
import { AssetCategoryEntity, AssetEntity } from 'src/modules/assets';
import { ProfessionalsDownloadsDocumentType } from '../../types';
import ProfessionalsDownloadsDocumentsListing from '../listing/ProfessionalsDownloadsDocumentsListing';

export interface ProfessionalsDownloadsDocumentsPageProps {
  type: ProfessionalsDownloadsDocumentType;
  displayGroupKey?: boolean;
  page: { assets: AssetEntity[]; assetCategories: AssetCategoryEntity[] };
}

const ProfessionalsDownloadsDocumentsPage: React.FunctionComponent<ProfessionalsDownloadsDocumentsPageProps> = (
  props
) => {
  const { type, displayGroupKey = true } = props;
  const { assets: unfilteredAssets, assetCategories } = props.page;

  const { outputChannel, intl, getLocalizedObjects } = useLocale();

  const pageProperties = {
    title: intl.formatMessage({
      id: `page/professionals/downloads/documents/${type}/head/page_title`,
    }),
    description: intl.formatMessage({
      id: `page/professionals/downloads/documents/${type}/head/meta_description`,
    }),

    breadcrumbs: [
      {
        title: intl.formatMessage({ id: 'breadcrumbs/professionals' }),
        href: '/professionals',
        as: '/professionals',
      },
      {
        title: intl.formatMessage({ id: 'breadcrumbs/professionals/downloads' }),
        href: '/professionals/downloads',
        as: '/professionals/downloads',
      },
      {
        title: intl.formatMessage({ id: `breadcrumbs/professionals/downloads/${type}` }),
        href: `/professionals/downloads/${type}`,
        as: `/professionals/downloads/${type}`,
      },
    ],
  };

  const filteredAssets = unfilteredAssets
    .filter((a) => a.channels && a.channels.includes(`${outputChannel}_media`))
    .sort((a, b) => (a.name < b.name ? -1 : 1));

  const assets = getLocalizedObjects<AssetEntity>(filteredAssets);

  const assetGroups = {};

  assetCategories.forEach((assetCategory) => {
    assetGroups[assetCategory.key] = assets.filter(
      (asset) => asset.asset_category.id === assetCategory.id
    );
  });

  return (
    <LayoutPage {...pageProperties}>
      <LayoutPageHeading
        titleKey={`page/professionals/downloads/documents/${type}/title`}
        sublineKey={`page/professionals/downloads/documents/${type}/subline`}
      />

      <section>
        <ProfessionalsDownloadsDocumentsListing
          assetGroups={assetGroups}
          displayGroupKey={displayGroupKey}
        />
      </section>
    </LayoutPage>
  );
};

export default ProfessionalsDownloadsDocumentsPage;
